export default function Products() {
  const items = [
    // RICE
    {
      id: "ponni-boiled",
      name: "Ponni Boiled Rice",
      image: "/images/ponni-boiled-rice.png",
      desc: "Premium quality boiled rice for export.",
    },
    {
      id: "ponni-raw",
      name: "Ponni Raw Rice",
      image: "/images/ponni-raw-rice.png",
      desc: "High-grade raw rice with rich taste.",
    },
    {
      id: "basmati",
      name: "Basmati Rice",
      image: "/images/basmati-rice.png",
      desc: "Long grain aromatic basmati rice.",
    },

    // SPICES
    {
      id: "dry-chilli",
      name: "Dry Chilli",
      image: "/images/dry-chilli.png",
      desc: "Sun-dried red chilli with strong flavor.",
    },
    {
      id: "pepper",
      name: "Black Pepper",
      image: "/images/black-pepper.png",
      desc: "Premium export quality black pepper.",
    },
    {
      id: "cardamom",
      name: "Cardamom",
      image: "/images/cardamom.png",
      desc: "Aromatic green cardamom pods.",
    },
    {
      id: "turmeric",
      name: "Turmeric",
      image: "/images/turmeric.png",
      desc: "Natural turmeric with high curcumin.",
    },
    {
      id: "cinnamon",
      name: "Cinnamon",
      image: "/images/cinnamon.png",
      desc: "Fresh cinnamon sticks for export.",
    },
    {
      id: "coriander",
      name: "Coriander",
      image: "/images/coriander.png",
      desc: "Clean and dried coriander seeds.",
    },
    {
      id: "cumin",
      name: "Cumin",
      image: "/images/cumin.png",
      desc: "Premium cumin seeds with strong aroma.",
    },
    {
      id: "jeera",
      name: "Jeera",
      image: "/images/jeera.png",
      desc: "High-quality jeera for global markets.",
    },

    // PULSES
    {
      id: "toor-dal",
      name: "Toor Dal",
      image: "/images/toor-dal.png",
      desc: "Export quality split pigeon peas.",
    },
    {
      id: "urad-dal",
      name: "Urad Dal",
      image: "/images/urad-dal.png",
      desc: "Premium urad dal with high protein.",
    },
    {
      id: "channa-dal",
      name: "Channa Dal",
      image: "/images/channa-dal.png",
      desc: "Clean and processed channa dal.",
    },
    {
      id: "moong-dal",
      name: "Moong Dal",
      image: "/images/moong-dal.png",
      desc: "Healthy and nutritious moong dal.",
    },

    // OTHER
    {
      id: "maize",
      name: "Maize",
      image: "/images/maize.png",
      desc: "High-quality maize grains for export.",
    },
    {
      id: "betel-nut",
      name: "Betel Nut",
      image: "/images/betel-nut.png",
      desc: "Carefully processed betel nuts.",
    },
  ];

  return (
    <section id="products" className="py-16 bg-gray-100">
      <h2 className="text-3xl text-center font-bold mb-10">
        Our Products
      </h2>

      <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 px-6">
        {items.map((item) => (
          <div
            key={item.id}
            className="group relative bg-white rounded-xl overflow-hidden shadow hover:shadow-2xl transition duration-500"
          >
            {/* IMAGE */}
            <div className="w-full h-36 flex items-center justify-center bg-gray-50">
              <img
                src={item.image}
                alt={item.name}
                className="max-h-28 object-contain group-hover:scale-110 transition duration-500"
              />
            </div>

            {/* HOVER DETAILS */}
            <div className="absolute inset-0 bg-black/70 opacity-0 group-hover:opacity-100 transition duration-500 flex flex-col items-center justify-center text-center text-white p-4">
              
              <h3 className="text-lg font-semibold mb-2">
                {item.name}
              </h3>

              <p className="text-sm mb-4 opacity-90">
                {item.desc}
              </p>

              <button className="bg-white text-black px-4 py-2 rounded hover:bg-gray-200">
                Enquire
              </button>
            </div>

            {/* NAME (default view) */}
            <div className="p-4 text-center">
              <h3 className="font-semibold text-lg">
                {item.name}
              </h3>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}